export default __webpack_public_path__ + "static/age-character-08694ab5b2b2fa203bd03892201c655d.svg";